import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=2fd73f64&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=2fd73f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd73f64",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIBreadcrumb: require('/opt/build/repo/components/UI/Breadcrumb.vue').default,JobsJobDetail: require('/opt/build/repo/components/Jobs/JobDetail.vue').default,UIMap: require('/opt/build/repo/components/UI/Map.vue').default,FormsLoginFormCompact: require('/opt/build/repo/components/Forms/LoginFormCompact.vue').default,JobsJobPagination: require('/opt/build/repo/components/Jobs/JobPagination.vue').default,JobsJobGuides: require('/opt/build/repo/components/Jobs/JobGuides.vue').default,JobsJobFeed: require('/opt/build/repo/components/Jobs/JobFeed.vue').default})
